// @flow
import React from 'react';

import { BaseMessageContainer } from './BaseMessageContainer';

export const WarningMessageContainer = ({ message, link, key = '' }) => (
  <BaseMessageContainer color="orange" key={key} link={link} message={message} />
);
